export enum ActivityEntityName {
    Job = 'Job',
    JobCreate = 'Job Create',
    WorkOrder = 'WorkOrder',
    Customer = 'Customer',
    Quote = 'Quote',
    QuoteJob = 'Quote Job',
    QuoteOpportunity = 'Quote Opportunity',
    QuotePro = 'Quote Pro',

    Work = 'Work',
    WorkItem = 'Work Item',

    PurchaseOrder = 'PO',
    PurchaseOrderLine = 'PO Line',
    PurchaseOrderLines = 'PO Lines',
    PurchaseOrderSupplier = 'PO Supplier',
    PurchaseOrderDeliveryAddress = 'PO Delivery Address',

    Invoice = 'Invoice',
    BulkInvoice = 'BulkInvoice',
    BulkInvoiceJob = 'BulkInvoiceJob',

    /** This is a variant of invoice used for entity data provider */
    InvoiceSite = 'InvoiceSite',

    InvoiceContact = 'InvoiceContact',
    InvoiceBillingCompany = 'InvoiceBillingCompany',

    PrepaymentInvoice = 'Prepayment Invoice',
    PrepaymentSupplier = 'Prepayment Supplier',

    CreditNote = 'Credit Note',
    CreditNoteSupplier = 'Credit Note Supplier',

    Bill = 'Bill',
    None = 'None',
    Compliance = 'Compliance',

    AccountingPackage = 'Accounting Package',

    Payment = 'Payment',
    TimeSegment = 'Time Segment',
    TimeSheet = 'Time Sheet',
    TimeSheetLog = 'Time Sheet Log',
    TimeSheetDuration = 'Time Sheet Duration',
    TimeSheetBillingOption = 'Time Sheet Billing Option',
    TimeSheetRate = 'Time Sheet Rate',
    TimeSheetTotal = 'Time Sheet Total',

    Contact = 'Contact',
    Employee = 'Employee',
    ContactEmployee = 'Contact Employee',
    ContactInvite = 'Contact Invite',

    Account = 'Account',
    Zone = 'Zone',
    Allocation = 'Allocation',
    CreditAllocation = 'Credit Allocation',
    Code = 'Code',
    EmbeddedCode = 'Embedded Code',
    Item = 'Item',
    ItemPending = 'Item Pending',
    Utility = 'Utility',

    Asset = 'Asset',
    AssetLink = 'AssetLink',

    EquipmentLink = 'EquipmentLink',

    Equipment = 'Equipment',

    EquipmentBulk = 'Equipment-Bulk',
    EquipmentSerialised = 'Equipment-Serialised',
    EquipmentVehicle = 'Equipment-Vehicle',

    EquipmentInternalSerialised = 'Equipment-Internal-Serialised',
    EquipmentInternalVehicle = 'Equipment-Internal-Vehicle',

    EquipmentCreate = 'Equipment-Create',
    EquipmentBulkCreate = 'Equipment-Bulk-Create',
    EquipmentSerialisedCreate = 'Equipment-Serialised-Create',
    EquipmentVehicleCreate = 'Equipment-Vehicle-Create',

    StockLocationEquipment = 'Stock Location Equipment',
    StockLocation = 'Stock Location',
    StockMovement = "Stock Movement",
    StockLevel = 'Stock Level',

    Defect = 'Defect',
    WorkRole = 'Work Role',
    Resource = 'Resource',
    JobTemplate = 'Job Template',
    Lead = 'Lead',
    Opportunity = 'Opportunity',
    OpportunityStage = 'Opportunity Stage',
    OpportunityAccount = 'Opportunity Account',
    //DO NOT REMOVE, NEED TO USE THIS AS IT CORRESPONDS TO THE OLD CONTACT TYPE OF SITE, WHICH IS USED IN THE CRM
    Site = 'Site',
    ///
    SitePro = 'Site Pro',
    SiteTiny = 'Site Tiny',
    ManagedSite = 'Managed Site',
    AccountSite = 'Account Site',
    SiteProValidated = 'Site Pro Validated',
    SiteContactValidated = 'Site Contact Validated',
    SiteProContacts = 'Site Pro Contacts',

    Company = 'Company',
    CustomFields = 'Custom Fields',
    Variation = 'Variation',
    SaleOrder = "Sale Order",
    SaleOrderItems = "Sale Order Items",

    WorkType = 'Work Type',
    JobType = 'JobType',
    Supplier = 'Supplier',
    Contractor = 'Contractor',
    PriceList = 'PriceList',
    TaxRate = 'TaxRate',
    Address = 'Address',
    Activity = 'Activity',
    Form = 'Form',
    FormResponse = 'FormResponse',
    FormResponseLink = 'FormResponseLink',
    FormTemplate = 'FormTemplate',
    SecurityRole = 'Security Role',
    TenantSetting = 'Tenant Setting',
    Catalogue = 'Catalogue',

    Project = 'Project',
    CodeCategory = 'Code Category',
    UoM = 'UoM',
    AssetType = 'Asset Type',
    Priority = 'Priority',

    Task = 'Task',
    Attachment = "Attachment",

    QuoteTemplate = 'Quote Template',
    DocumentTheme = 'Document Theme',
    UOM = 'UOM',
    JobStatus = 'Job Status',
    WorkOrderStatus = 'Work Order Status',
    BasicContact = 'Basic Contact',
    LoginContact = 'Login Contact',
    JobPolicy = "Job Policy",
    QuotePolicy = "Quote Policy",
    File = "File",
    Tag = "Tag",
    JobStages = "Job Stages",
    WorkBuddyCompany = "WorkBuddyCompany",

    RecurringJob = "Recurring-Job",
    RecurringService = "Recurring-Service",
    RecurringNextService = "RecurringNextService",
    RecurringLastService = "RecurringLastService",
    RecurringSchedule = "RecurringSchedule",
    RecurringRule = "RecurringRule",
    RecurringConfirmation = 'RecurringConfirmation',

    EntityLink = 'Entity Link',

    EntityStatus = 'Entity Status',
    EntitySubStatus = 'Entity Sub Status',
    ContactLink = "ContactLink",
    ServiceConfirmation = 'Service Confirmation',

    /** This is used to provide entity pickers for operations based on the view */
    LegacyJob = 'LegacyJob',
    ServiceEntity = "ServiceEntity",

    WorkOrderDispatch = 'WorkOrderDispatch',
    PurchaseOrderBillingCompany = "PurchaseOrderBillingCompany",
    PurchaseOrderAccountingPackage = "PurchaseOrderAccountingPackage", // Use in document theme

    /** Virtual Entity: use for entity data */
    JobAsset = 'Job Asset',
    AssetRecurringJob = 'Asset Recurring Job',

    Agreement = 'Agreement',

    HomesNSWNotice = 'HomesNSWNotice',
    HomesNSWNoticeLineItem = 'HomesNSWNoticeLineItem',

    Tenant = 'Tenant',
    WorkCategory = 'WorkCategory',
    OAuth2Application = "OAuth2Application",
}

